#!/usr/bin/env node
import { Command } from 'commander'
import { init } from './commands/init'
import { add } from './commands/add'
import { version } from '../package.json'

const program = new Command()

program
    .name('bismillahcss')
    .description('Futuristic CSS framework for modern web development')
    .version(version)

program.addCommand(init)
program.addCommand(add)

program.parse()
